<template>
  <div>
    <template v-if="viewPage == true">
      <div class="modal fade" id="batchSummary" tabindex="-1" role="dialog" aria-labelledby="batchSummaryLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-body batchSummary-payment-popup text-left p-4">
              <div class="popup-head line-head">
                <h2 class="pb-2"> Summary </h2>
              </div>
              <div class="row normal-ib-space mt-3">
                <div class="col-md-12 mb-3">
                  <table width="100%" v-if="batchSummary != null">
                    <tr>
                      <td> Transaction inserted </td>
                      <td id="inserted_rows"> {{ inserted }} </td>
                    </tr>
                    <tr>
                      <td> Discrepant Transaction </td>
                      <td id="discrepant_rows"> {{ discrepants }} </td>
                    </tr>
                    <tr>
                      <td> Already exist Transactions </td>
                      <td id="existing_rows"> {{ already_exist }} </td>
                    </tr>
                  </table>
                </div>
                <div class="col align-right">
                  <button class="btn btn-primary" v-on:click="proceedToTransferOut"> Proceed </button>
                  <button class="btn btn-primary" v-if="discrepantBills.length > 0" v-on:click="csvExport"> Download Discrepants</button>
                  <button class="btn btn-primary" v-if="alreadyExistBills.length > 0" v-on:click="csvExportExist"> Download Existing</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="clearfix">
        <div class="page-top mb-1 mb-3 align-center clearfix">
          <h1 class="float-left"> Transfer Out Bulk Upload </h1>
          <div class="progress-bar-holder">
            <div class="progress step-one">
              <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <ul class="prgress-number">
              <li class="progress-number-list active">
						<span class="bullet">
							1
						</span>
                <p> Upload </p>
              </li>
              <li class="progress-number-list" id="progressNumberListTwo">
						<span class="bullet">
							2
						</span>
                <p> Field Mapping </p>
              </li>
            </ul>
          </div>
          <button class="btn btn-primary float-right mr-1" id="process_dropzone_queue" v-show="proceedButtonflag"> Proceed </button>
          <router-link class="btn btn-primary float-right mr-1" to="/financeTransferOutList"> Cancel </router-link>
        </div>
        <div class="batch-upload-main">
          <div class="batch-upload-inner">
            <div class="upload-sheet" v-show="previewMapField === false">
              <div class="form-group">
                <input type="text" placeholder="What would you like to call this batch?" class="form-control" v-model="title" @change="handleGeneratePayrollButton()" />
              </div>
              <label for="" class="label block-label upload-label"> Upload a CSV <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title=".CSV is an Microsoft Excel file format which is a requirement for Payroll Plus to read your file. You can save your Excel file into a .CSV file using 'save as' option listed under file menu on your Excel program."></i>
              </label>
              <!--              <p> Bill Companies list download <a :href="`${$global.aws_base_url}/csv/BillCompaniesList.csv`">here</a>. </p>-->
              <p>
                You can also download a sample template <a :href="`${$global.aws_base_url}/csv/BulkTransferIn.csv`">here</a>. </p>
                <p>
                  You also have the option to download a list of companies <a :href="`${$global.aws_base_url}/csv/Company.csv`">here</a>. </p>
              <form  method="post" class="box dropzone drozone-label dz-clickable dropzone content mt-4" action="/upload" id="drop" data-toggle="tooltip" data-placement="left" title="<p class='align-left'>Your CSV file must have the following in order to upload bulk Transfer In: <br/>
							1. Company Account Number.<br/>
							2. Amount.<br/>
							3. Description.<br/>
							4. Transaction Reference No.<br/>
							5. Date.<br/></p>">
                <div class="box__input dz-message">
                  <label class="drozone-label" for="file">
                    <img  id="uploadIcon" for="file" src="/images/svgs/upload-icon.svg" alt="" class="upload">
                    <span for="file" class="filename"> Drop your file here </span>
                  </label>
                  <label class="uploadedFileName">Drop your file here</label>
                </div>
              </form>
              <em class="dropzone-or"> Or </em> <label id="selectFromComputer" class="btn btn-primary select-file-btn"> Select from your computer </label>
            </div> <!-- upload sheet -->
            <div class="previewMapField" v-show="previewMapField === true">
              <div class="mandatory-fields mb-4">
                <label for="" class="label block-label upload-label mb-3"> Mandatory Information <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title="These fields are required for Payroll Plus to process your sheet."></i> </label>
                <div class="mandatory-tags">
                  <div class="mandatory-fields-inner">
                    <div class="mandatory-field-col"> <span class="map-value" title="Student ID"> <i v-show="mand_company" class="fas fa-check"></i> Company Account Number </span> </div>
                    <div class="mandatory-field-col"> <span class="map-value" title="Student ID"> <i v-show="mand_amount" class="fas fa-check"></i> Amount </span> </div>
                    <div class="mandatory-field-col"> <span class="map-value" title="No. of invoices"> <i v-show="mand_description" class="fas fa-check"></i> Description </span> </div>
                    <div class="mandatory-field-col"> <span class="map-value" title="Due Date Interval"> <i v-show="mand_referenceNo" class="fas fa-check"></i> Transaction Reference No </span> </div>
                    <div class="mandatory-field-col"> <span class="map-value" title="Due Date First Invoice"> <i v-show="mand_date" class="fas fa-check"></i> Date </span> </div>

                  </div>
                </div>
              </div>
              <label for="" class="label block-label upload-label"> Preview and map your identifiers <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title="Please review the below identifiers in line with the columns in your sheet."></i>
              </label>
              <p> Please check if we have correctly picked your data. </p>
              <div class="fields-mapping mt-4" id="fieldmapping_table">
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="viewPage == null">
      <preLoader></preLoader>
    </template>
    <template v-if="viewPage == false">
      <notAllowed></notAllowed>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      viewPage : true,
      previewMapField : false,
      fileAdded : false,
      dropZoneObject : null,

      mand_title : false,
      title:'',

      mand_company : false,
      mand_amount : false,
      mand_date : false,
      mand_referenceNo : false,
      mand_description : false,

      mand_companyName : false,
      mand_billerCode : false,


      proceedButtonflag : false,
      batchSummary : [],
      discrepantBills : {},
      alreadyExistBills : {},
      inserted : null,
      discrepants : null,
      already_exist : null,
    }
  },
  methods: {
    processDropzoneQueue(){

    },
    handleGeneratePayrollButton(){
      if(this.fileAdded == true){
        $('a#payroll_proceed_top,a#payroll_proceed_bottom').removeAttr('disabled','disabled').addClass('active');
        if(this.isAPIAvailable()){
          $.when(this.printTable(this.dropZoneObject.files[0]));
        }
      }else{
        $('a#payroll_proceed_top,a#payroll_proceed_bottom').attr('disabled','disabled').removeClass('active');
      }
    },
    csvExportExist() {
      let that = this;
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += [
        [
          'Company',
          'Amount',
          'Description',
          'Reference No',
          'Date',
        ],
        ...that.alreadyExistBills.map(item => item)
      ]
          .join("\n")
          .replace(/(^\[)|(\]$)/gm, "");
      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "Existing Bills.csv");
      link.click();
    },
    csvExport() {
      let that = this;
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += [
        [
          'Company',
          'Amount',
          'Description',
          'Reference No',
          'Date',
        ],
        ...that.discrepantBills.map(item => item)
      ]
          .join("\n")
          .replace(/(^\[)|(\]$)/gm, "");
      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "Descrepant Bills.csv");
      link.click();
    },
    proceedToBills(){
      $('#batchSummary').modal('hide');
      this.$router.push('billPayments');
    },
    proceedToTransferOut(){
      $('#batchSummary').modal('hide');
      this.$router.push('financeTransferOutList');
    },
    initDropZone() {
      var that = this;
      Dropzone.options.drop = {
        addRemoveLinks: true,
        paramName: 'file',
        maxFilesize: 2, // MB
        uploadMultiple: false,
        maxFiles: 1,
        minFiles: 1,
        queueLimit:1,
        url: that.$global.base_url+'api/financeTransferOutInBulk',
        acceptedFiles: '.csv',
        autoProcessQueue:false,
        headers: window.axios.defaults.headers.common,
        init: function(){
          var _this = this;
          that.dropZoneObject = this;
          var selectedFile = document.getElementById('selectFromComputer');
          selectedFile.addEventListener('click',function(){
            _this.hiddenFileInput.click();
          });
          this.on("maxfilesexceeded", function(file) {
            this.removeAllFiles();
            this.addFile(file);
          });
          this.on('removedfile',function(file){
            that.fileAdded = false;
            $('div.box__input').show();
          }),
              this.on("addedfile", function(file) {
                that.fileAdded = true;
                that.checkFileForErrors(file);
                that.handleGeneratePayrollButton();
              });
          var submitButton_top 	= document.querySelector("#process_dropzone_queue");
          function processFileLocal(){
            if(that.isAPIAvailable()){
              $.when(that.printTable(that.dropZoneObject.files[0]));
            }
          }
          function processQueueLocal(){
            $('div.progress').addClass('step-three').removeClass('step-two');
            that.dropZoneObject.processQueue(); // Tell Dropzone to process all queued files.
          }
          submitButton_top.addEventListener("click", function(e) {
            processQueueLocal();
          });
          that.dropZoneObject.on("sending", function(file, xhr, formData) {
            that.$Progress.start();
            // Will send the filesize along with the file as POST data.
            formData.append("filesize", file.size);
            var mapIdentifier = [];
            var selVal = '';
            $( "select.selectpicker" ).each(function() {
              selVal = $(this).find('option:selected').val();
              mapIdentifier.push(selVal);
              selVal = '';
            });
            formData.append("mapIdentifier", JSON.stringify(mapIdentifier));
            formData.append("_token",$('meta[name="csrf-token"]').attr('content'));
            formData.append("sheetName", that.title);
          });

          that.dropZoneObject.on("totaluploadprogress", function(progress) {

          });

          that.dropZoneObject.on("uploadprogress", function(file, progress, bytesSent) {
            // Update progress bar with the value in the variable "progress", which
            // is the % total upload progress from 0 to 100
            var progressBar = Math.floor(progress);
            if(progressBar == 100){
              that.$Progress.finish();
            }
          });

          that.dropZoneObject.on("success", function(file, obj) {
            if(obj.code == "200") {
              that.showToastBox('success',obj.message);
              that.proceedToTransferOut();
            }else if(obj.code == "204"){
              that.showAlertBox('error',obj.msg);
            }else{ console.log('1');
              that.showAlertBox('error','Error in file');
            }
          });
          that.dropZoneObject.on('error',function(file,errorMessage,xhr){
            if(!file.accepted){
              this.fileAdded = false;console.log('2');
              that.showAlertBox('error','Error in file');
              this.removeFile(file);
            }
            var msg = 'Error:'+xhr.status+' '+xhr.statusText;
            that.showAlertBox('error','Error in file', msg);
            file.status = Dropzone.QUEUED;
          });
        }
      };
      $('.cross').on('click', function(e){
        that.dropZoneObject.removeAllFiles();
        $('label.uploadedFileName').html('Drop your file here');
      });
    },
    isAPIAvailable() {
      // Check for the various File API support.
      if (window.File && window.FileReader && window.FileList && window.Blob) {
        // Great success! All the File APIs are supported.
        return true;
      } else {
        var error_message = 'The HTML5 APIs used in this form are only available in the following browsers:<br /> - Google Chrome: 13.0 or later<br /> - Mozilla Firefox: 6.0 or later<br /> - Internet Explorer: Not supported (partial support expected in 10.0)<br /> - Safari: Not supported<br /> - Opera: Not supported';
        this.showAlertBox('error',error_message);
        return false;
      }
    },
    printTable(file) {
      var reader = new FileReader();
      reader.readAsText(file);
      var that = this;
      reader.onload = function(event){
        var csv = event.target.result;
        var data = $.csv.toArrays(csv);
        var test 		= '';
        var selected 	= '';
        var col = [];
        for(var row in data) {
          if(row > 1) break;
          for(var item in data[row]) {
            if(row == 0){
              col[item] = [data[row][item]];
            }else{
              col[item].push(data[row][item]);
            }
          }
        }
        for(var row1 in col) {
          var rowName = '';
          var rowValue = '';
          var comboBox = '';
          var fieldMap = false;
          for(var item1 in col[row1]) {
            if(item1 > 1){ break; }
            if(item1 == 0){
              rowName = col[row1][item1];
            }else{
              rowValue += '<p>' + col[row1][item1] + '</p>';
            }
          }

          // check for if you find the Name in you ddList
          if(rowName.trim().toLocaleLowerCase() == 'company account number'){
            that.mand_company = fieldMap = true;
          }
          if(rowName.trim().toLocaleLowerCase() == 'description'){
            that.mand_description = fieldMap = true;
          }
          if(rowName.trim().toLocaleLowerCase() == 'amount'){
            that.mand_amount = fieldMap = true;
          }
          if(rowName.trim().toLocaleLowerCase() == 'date'){
            that.mand_date = fieldMap = true;
          }
          if(rowName.trim().toLocaleLowerCase() == 'transaction reference no'){
            that.mand_referenceNo = fieldMap = true;
          }
          comboBox += '<select name="'+row1+'" class="selectpicker show-menu-arrow custom-select2" data-size="5">';
          comboBox += '<option value="do-not"> - Select - </option>';

          selected = (rowName.trim().toLocaleLowerCase() == 'company account number') ? 'selected' : '';
          fieldMap = (rowName.trim().toLocaleLowerCase() == 'company account number') ? true : fieldMap;
          comboBox += '<option value="Company Account Number" '+selected+'>Company Account Number</option>';

          selected = (rowName.trim().toLocaleLowerCase() == 'amount') ? 'selected' : '';
          fieldMap = (rowName.trim().toLocaleLowerCase() == 'amount') ? true : fieldMap;
          comboBox += '<option value="Amount" '+selected+'>Amount</option>';

          selected = (rowName.trim().toLocaleLowerCase() == 'description') ? 'selected' : '';
          fieldMap = (rowName.trim().toLocaleLowerCase() == 'description') ? true : fieldMap;
          comboBox += '<option value="Description" '+selected+'>Description</option>';

          selected = (rowName.trim().toLocaleLowerCase() == 'transaction reference no') ? 'selected' : '';
          fieldMap = (rowName.trim().toLocaleLowerCase() == 'transaction reference no') ? true : fieldMap;
          comboBox += '<option value="Transaction Reference No" '+selected+'>Transaction Reference No</option>';

          selected = (rowName.trim().toLocaleLowerCase() == 'date') ? 'selected' : '';
          fieldMap = (rowName.trim().toLocaleLowerCase() == 'date') ? true : fieldMap;
          comboBox += '<option value="Date" '+selected+'>Date</option>';

          comboBox += '</select>';
          if(fieldMap == true){
            test += '<div class="row mapped align-items-center">';
          }else{
            test += '<div class="row align-items-center">';
          }
          test += '<div class="col-md-1"><div class="fields-mapping-inner"><i class="fas fa-check-circle"></i></div></div>';
          test += '<div class="col-md-7"><div class="fields-mapping-inner"><p> '+rowName+' </p><p> '+rowValue+' </p></div></div>';
          test += '<div class="col-md-4"><div class="fields-mapping-inner">';
          test += comboBox;
          test += '</div></div>';
          test += '</div>';
        }
        $('#fieldmapping_table').html(test);
        that.previewMapField = true;
        that.generateButtonProccess();
        $('select.selectpicker').selectpicker('refresh');
        that.assignComboFunction();
        $('div.progress').addClass('step-two');
      };
      reader.onerror = function(){ this.showAlertBox('error','Unable to read ' + file.fileName); }.bind(this);
    },
    generateButtonProccess(){
      if(this.mand_company == true && this.mand_description == true && this.mand_amount == true && this.mand_date == true && this.mand_referenceNo == true){
        this.proceedButtonflag = true;
      }else{
        this.proceedButtonflag = false;
      }
    },
    checkForMandField(){
      $( "select.selectpicker" ).each(function() {
        this.mand_company = this.mand_description = this.mand_amount = this.mand_date = this.mand_referenceNo = false;
        var selVal = $(this).find('option:selected').val();
        if(selVal.trim().toLowerCase() == 'company account number') this.mand_company = true;
        if(selVal.trim().toLowerCase() == 'description') this.mand_description = true;
        if(selVal.trim().toLowerCase() == 'amount') this.mand_amount = true;
        if(selVal.trim().toLowerCase() == 'date') this.mand_date = true;
        if(selVal.trim().toLowerCase() == 'transaction reference no') this.mand_referenceNo = true;
      });

    },
    assignComboFunction(){
      var that = this;
      // Auto Mapped value make disabled
      $('select.selectpicker').each(function(index,obj){
        $('select.selectpicker option[value="'+obj.value+'"]').attr('disabled',true);
      });
      $(that.$el).find('.selectpicker').selectpicker('refresh');
      var previous;
      $('select.selectpicker').on('shown.bs.select',function(){
        previous = this.value;
      }).change(function(){
        var selVal = $(this).find('option:selected').val();
        $('select.selectpicker option[value="'+previous+'"]').attr('disabled',false);
        //hide the department, branch and city field sets if deselect
        $('select.selectpicker option[value="'+selVal+'"]').attr('disabled',true);
        $(that.$el).find('.selectpicker').selectpicker('refresh');

        var flag = false;
        that.checkForMandField();
        if(selVal.trim().toLowerCase() == 'company account number') that.mand_company = true;
        if(selVal.trim().toLowerCase() == 'description') that.mand_description = true;
        if(selVal.trim().toLowerCase() == 'amount') that.mand_amount = true;
        if(selVal.trim().toLowerCase() == 'date') that.mand_date = true;
        if(selVal.trim().toLowerCase() == 'transaction reference no') that.mand_referenceNo = true;

        that.generateButtonProccess();
      });
    },
    checkFileForErrors(file){
      var reader = new FileReader();
      reader.readAsText(file);
      var that = this;
      reader.onload = function(event){
        var csv = event.target.result;
        var data = $.csv.toArrays(csv);
        var col = [];
        var column = false;
        for(var row in data) {
          if(row == 0){
            for(var item in data[row]) {
              var value = data[row][item];
              value = value.replace(/[^\w\s]/gi,'');
              col.push(value);
            }
          }else{
            break;
          }
        }
        if(col.length < 3 && that.fileAdded == true){
          column = true;
          that.showAlertBox('error','Missing column');
        }
        if(column == true){
          that.dropZoneObject.removeAllFiles();
        }
      };
      reader.onerror = function(){ this.showAlertBox('Unable to read ' + file.fileName); }.bind(this);
    },
  },
  created() {
  },
  mounted(){
    var that = this;
    this.initDropZone();
    $(".drozone-label").tooltip({
      html	: true,
      template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner large"></div></div>',
    });
    $("#drop").dropzone();
    $(window.document).on('show.bs.modal', '.modal', function (event) {
      var zIndex = 1040 + (10 * $('.modal:visible').length);
      $(this).css('z-index', zIndex);
      setTimeout(function() {
        $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
      }, 0);
    });

    /*this.$Progress.start();
    $('.selectpicker').selectpicker();
    this.can('bill_payments').then(result => {
        this.bill_payments = result.bill_payments;
    }).then(result => {
        if(this.bill_payments == true){
            this.viewPage = true;
            this.$Progress.finish();
        }else{
            this.$Progress.finish();
        }
    });*/
  }
}
</script>
